<!-- Company Component  -->

<app-admin-header [header]="header" [links]="links" [breadcrumbs]="breadcrumbs" [stats]="stats"></app-admin-header>
<div class="container-fluid v4-bg-img">
  <div class="row custom-margin py-3">
    <div class="col-md-8 col-12 p-0">
      <div class="container mb-4">
        <app-no-data *ngIf="data.length == 0 && !skelition"></app-no-data>
        <app-table [unit]="'COMPANY'" *ngIf="data.length > 0" [data]="data"
          (actionCall)="actionCall($event)"></app-table>
      </div>
    </div>

    <div class="col-md-4 col-12 p-0" *ngIf="
      questions.length > 0 &&
      !skelition &&
      permissionService.hasPermission('COMPANY', 'c')
    ">
      <div class="container mb-5">
        <h2 class="text-center color-grey">
          <i style="font-size: 2rem" class="pi pi-fw pi-plus-circle mx-2 color-grey"></i>{{ "Add Company" |
          translator }}
        </h2>
        <app-dynamic-form [questions]="questions" (sendData)="receiveData($event)"></app-dynamic-form>
        <p-messages [(value)]="messages" [enableService]="false"></p-messages>
      </div>
    </div>
  </div>
</div>
<!-- skelition   -->
<app-skelitions [hidden]="!skelition" [value]="1" class="mb-2"></app-skelitions>

<!-- Confirm Modal -->
<p-confirmDialog [style]="{ margin: '0rem 1rem' }"></p-confirmDialog>

<!-- Update Data Modal -->
<p-dialog [blockScroll]="true" [draggable]="false" header="Header" [(visible)]="updateModal"
  [style]="{ margin: '0rem 1rem' }">
  <ng-template pTemplate="header">
    <span class="text-xl font-bold">{{ "Update Company" | translator }}</span>
  </ng-template>
  <app-dynamic-form *ngIf="updateModal" [questions]="updateQuestions"
    (sendData)="UpdateData($event)"></app-dynamic-form>
</p-dialog>

<app-footer></app-footer>